import { SOKO_GRID_EMAIL, SOKO_GRID_WEBSITE_URL } from "@/src/config/contact";

export const DEFAULT_WEB_BASE_URL = SOKO_GRID_WEBSITE_URL;

export function normalizeWebBaseUrl(value?: string | null): string {
  const trimmed = String(value || "").trim();
  const withFallback = trimmed || DEFAULT_WEB_BASE_URL;

  return withFallback.replace(/\/+$/g, "");
}

function getDomainFromUrl(value: string): string {
  return value.replace(/^https?:\/\//i, "").replace(/\/.*$/g, "");
}

export const WEB_BASE_URL = normalizeWebBaseUrl(
  process.env.EXPO_PUBLIC_WEB_BASE_URL
);

export const WEB_BASE_DOMAIN = getDomainFromUrl(WEB_BASE_URL);

export function buildPublicBusinessCardUrl(slug?: string | null): string {
  const cleanSlug = String(slug || "")
    .trim()
    .replace(/^\/+/g, "")
    .replace(/^p\//i, "");

  return cleanSlug ? `${WEB_BASE_URL}/p/${cleanSlug}` : WEB_BASE_URL;
}

export const BRAND = {
  appName: "Soko Grid",
  legalName: "Soko Grid Ltd",
  slogan: "Showcase. Connect. Grow.",

  domain: WEB_BASE_DOMAIN,
  websiteUrl: WEB_BASE_URL,

  email: SOKO_GRID_EMAIL,
  supportEmail: SOKO_GRID_EMAIL,
  helloEmail: SOKO_GRID_EMAIL,
  billingEmail: SOKO_GRID_EMAIL,

  ownerPortalName: "Soko Grid Owner Portal",
  adminPortalName: "Soko Grid Admin",

  publicDescription:
    "Soko Grid helps shops and service providers create simple online storefronts that customers can discover, view, contact, and share.",

  seoTitle: "Soko Grid | Online Storefronts for Local Businesses",
  seoDescription:
    "Soko Grid helps shops and service providers in Kenya create simple online storefronts with products, services, location, contacts, reviews, and WhatsApp inquiries.",

  poweredBy: "Powered by Soko Grid",
  copyright: "© 2026 Soko Grid Ltd. All rights reserved.",
};
